<div>
  @if (loading) {
    <app-spinner />
  } @else {
    <!-- Sin card: se muestra dentro del modal "Datos de facturación" de la ficha del cliente -->
    <div>
      <!-- Abre directo en edición: el lápiz ya no hace falta
      <div class="flex justify-end">
        @if (editable) {
          <button *hasPermission="'clientes:edit'"
            type="button"
            class="w-9 h-9 flex items-center justify-center rounded-full ring-1 ring-inset ring-gray-300 text-gray-700 hover:bg-gray-50 hover:text-gray-900 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300"
            (click)="editableSwitcher()"
            [disabled]="process"
            aria-label="Editar datos de facturación"
            title="Editar"
          >
            <mat-icon fontIcon="edit"></mat-icon>
          </button>
        }
      </div>
      -->
      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <div>
            <app-label for="razon_social">
              Razón social
            </app-label>
            <app-input-field id="razon_social" formControlName="razon_social" />
          </div>

          <div>
            <app-label for="direccion_fiscal">
              Dirección fiscal
            </app-label>
            <app-input-field id="direccion_fiscal" formControlName="direccion_fiscal" />
          </div>

          <div>
            <app-label for="telefono">
              Teléfono
            </app-label>
            <app-input-field id="telefono" formControlName="telefono" />
          </div>

          <div>
            <app-label for="email">
              Email
            </app-label>
            <app-input-field id="email" type="email" formControlName="email" />
          </div>
        </div>
      </app-form>
    </div>

    <app-edition-buttons *hasPermission="'clientes:edit'"
      [valid]="editForm.valid"
      [editable]="editable"
      [process]="process"
      [hideEditButton]="true"
      (onUpdateClick)="submitDatoFacturacion()"
      (onEditClick)="editableSwitcher()"
      (onCancelClick)="onCancel()"
    />

    <!-- Los contactos tienen su propia línea en la ficha del cliente
    <app-contactos-administrativos [cliClienteId]="clienteId" />
    -->
  }
</div>
